import React from 'react';
import Form from 'components/form';
import BuyerInput from 'components/input/BuyerInput';

export default function BuyerField(props) {
  return <Form.Field {...props} component={BuyerInput} />;
}
